/* 🤖 this file was generated by svg-to-ts */
export const mgcIconGrokFilled: {
  name: 'grok-filled';
  data: string;
} = {
  name: 'grok-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 3.047c-.733.14-1.4.821-1.537 1.57-.061.334-.061 14.432 0 14.766.141.768.806 1.433 1.574 1.574.334.061 14.432.061 14.766 0 .768-.141 1.433-.806 1.574-1.574.061-.334.061-14.432 0-14.766-.141-.768-.806-1.433-1.574-1.574-.307-.056-14.508-.052-14.803.004m10.742 4.014c.501.176.778.701.64 1.212-.035.13-.816 1.198-3.162 4.327-3.409 4.545-3.237 4.341-3.694 4.388a1.003 1.003 0 0 1-1.068-1.261c.065-.24 6.204-8.432 6.418-8.564a.972.972 0 0 1 .866-.102"/></svg>`
};
